<template>
  <div style="background-color: transparent;">
    <router-view></router-view>
  </div>
</template>

<script>
import 'normalize.css'
export default {
  name: "App",
  methods : {
    setMeta(route){
      // タイトルを設定
      if(route.meta.title){
        let setTitle = route.meta.title;
        document.title = setTitle;
        document.querySelector("meta[property='og:title']").setAttribute('content', setTitle)
      }
      // ディスクリプションを設定
      if(route.meta.desc){
        let setDesc = route.meta.desc;
        document.querySelector("meta[name='description']").setAttribute('content', setDesc)
        document.querySelector("meta[property='og:description']").setAttribute('content', setDesc)
      }
    }
  },
  mounted(){
    let route = this.$route;
    this.setMeta(route);
  },
  watch: {
    '$route' (route) {
      this.setMeta(route);
    }
  }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap');
*{
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: 400;
  font-style: normal;
}
</style>
